import React, { createContext, useContext, useState, useCallback } from "react";

const LANGS = ["fr", "en", "es"];
const LangCtx = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("ast_lang") || "fr");
  const change = useCallback((l) => {
    if (!LANGS.includes(l)) return;
    localStorage.setItem("ast_lang", l);
    setLang(l);
  }, []);
  // t: resolve a {fr,en,es} object to current language
  const t = useCallback((obj) => {
    if (obj == null) return "";
    if (typeof obj === "string") return obj;
    return obj[lang] ?? obj.fr ?? "";
  }, [lang]);
  return (
    <LangCtx.Provider value={{ lang, setLang: change, t, langs: LANGS }}>
      {children}
    </LangCtx.Provider>
  );
};

export const useLang = () => useContext(LangCtx);

// UI chrome dictionary
export const UI = {
  nav: {
    home: { fr: "Accueil", en: "Home", es: "Inicio" },
    programmes: { fr: "Sport-Études", en: "Sport-Study", es: "Deporte-Estudio" },
    immersions: { fr: "Immersions & Mobilité", en: "Immersions & Mobility", es: "Inmersiones y Movilidad" },
    evenements: { fr: "Événements & Tryouts", en: "Events & Tryouts", es: "Eventos y Tryouts" },
    ligue: { fr: "Ligue", en: "League", es: "Liga" },
    equipes: { fr: "Équipes", en: "Teams", es: "Equipos" },
    offre: { fr: "L'Offre", en: "The Offer", es: "La Oferta" },
    candidature: { fr: "Candidature", en: "Apply", es: "Candidatura" },
    infos: { fr: "Infos Pratiques", en: "Practical Info", es: "Info Práctica" },
    sherbrooke: { fr: "Sherbrooke BC", en: "Sherbrooke BC", es: "Sherbrooke BC" },
    legacy: { fr: "Legacy 3R", en: "Legacy 3R", es: "Legacy 3R" },
    alumni: { fr: "Alumni & Carrière", en: "Alumni & Careers", es: "Alumni y Carrera" },
    boutique: { fr: "Boutique", en: "Shop", es: "Tienda" },
  },
  cta: {
    join: { fr: "Nous rejoindre", en: "Join us", es: "Únete" },
    discover: { fr: "Découvrir", en: "Discover", es: "Descubrir" },
    contact: { fr: "Nous contacter", en: "Contact us", es: "Contáctanos" },
    all_programs: { fr: "Voir tous les programmes", en: "View all programs", es: "Ver todos los programas" },
    learn_more: { fr: "En savoir plus", en: "Learn more", es: "Saber más" },
  },
  form: {
    title: { fr: "Inscription & Contact", en: "Register & Contact", es: "Inscripción y Contacto" },
    subtitle: {
      fr: "Une question, une inscription ? Écrivez-nous, nous répondons sous 48h.",
      en: "A question or a registration? Write to us, we reply within 48h.",
      es: "¿Una pregunta o inscripción? Escríbenos, respondemos en 48h.",
    },
    name: { fr: "Nom complet", en: "Full name", es: "Nombre completo" },
    email: { fr: "Adresse email", en: "Email address", es: "Correo electrónico" },
    phone: { fr: "Numéro WhatsApp", en: "WhatsApp number", es: "Número de WhatsApp" },
    program: { fr: "Programme concerné", en: "Program of interest", es: "Programa de interés" },
    message: { fr: "Votre message", en: "Your message", es: "Tu mensaje" },
    send: { fr: "Envoyer ma demande", en: "Send my request", es: "Enviar solicitud" },
    sending: { fr: "Envoi…", en: "Sending…", es: "Enviando…" },
    success: { fr: "Merci ! Votre demande a bien été envoyée.", en: "Thank you! Your request has been sent.", es: "¡Gracias! Tu solicitud ha sido enviada." },
    error: { fr: "Une erreur est survenue. Réessayez.", en: "Something went wrong. Try again.", es: "Ocurrió un error. Inténtalo de nuevo." },
    general: { fr: "Demande générale", en: "General inquiry", es: "Consulta general" },
  },
  footer: {
    tagline: { fr: "Voyage · Basket · Expériences de vie", en: "Travel · Basketball · Life experiences", es: "Viaje · Baloncesto · Experiencias de vida" },
    follow: { fr: "Suivez l'aventure", en: "Follow the journey", es: "Sigue la aventura" },
    rights: { fr: "Tous droits réservés.", en: "All rights reserved.", es: "Todos los derechos reservados." },
    nav: { fr: "Navigation", en: "Navigation", es: "Navegación" },
  },
};

export const SOCIALS = [
  { name: "Instagram", url: "https://instagram.com/airsportstravel", icon: "instagram" },
  { name: "YouTube", url: "https://youtube.com/@airsportstravel", icon: "youtube" },
  { name: "Facebook", url: "https://facebook.com/airsportstravel", icon: "facebook" },
];
